import type { Call as TelnyxCall } from '@telnyx/webrtc';
import type { CallState } from './types';
import { CallInfoParser } from './CallInfoParser';
import { RemoteAudioChannel } from './RemoteAudioChannel';
import { WebRTCCallEventBus } from './WebRTCCallEventBus';

export class CallLifecycleHandler {
  constructor(
    private readonly remoteAudio: RemoteAudioChannel,
    private readonly eventBus: WebRTCCallEventBus,
    private readonly debug: (...args: unknown[]) => void,
    private readonly cleanup: () => void,
  ) {}

  handleActive(call: TelnyxCall, callInfo: Record<string, unknown>): void {
    const stream = call.remoteStream;
    if (stream && CallInfoParser.isMediaStream(stream)) {
      this.remoteAudio.attachStream(stream);
    }
    this.eventBus.emit('callConnected');
    this.debug('Call connected successfully', callInfo);
  }

  handleEnd(state: CallState, callInfo: Record<string, unknown>): void {
    const errorInfo = {
      ...callInfo,
      state,
      timestamp: new Date().toISOString(),
    };
    this.debug('Call hung up / destroyed with details:', errorInfo);
    this.cleanup();
    this.eventBus.emit('callHungUp', errorInfo);
  }
} 